<template>
  <main-layout page-title="灾情上报" class="increase">
    <template slot="main-content">
      <div class="main-content">
        <el-form
          ref="damageRef"
          :model="requestParams"
          :rules="rules"
          label-width="30%"
        >
          <el-form-item label="灾害名称">
            <el-input v-model="requestParams.disasterName" disabled />
          </el-form-item>
          <el-form-item label="申报地块栽培类型" prop="cultivationType">
            <el-select
              placeholder="请选择本次要申报的栽培类型"
              v-model="requestParams.cultivationType"
            >
              <el-option
                v-for="(level, key) in cultivation_type"
                :key="key"
                :value="key"
                :label="level"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="受灾程度：" prop="level">
            <template slot="label">
              受灾程度
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  <div>受灾程度说明：</div>
                  <div>受灾：指产量损失在10%~30%</div>
                  <div>成灾：指产量损失在30%~80%</div>
                  <div>绝收：指产量损失在80%以上</div>
                </div>
                <i class="el-icon-warning" />
              </el-tooltip>
            </template>
            <el-select
              placeholder="请选择本次要申报的受灾程度"
              v-model="requestParams.level"
            >
              <el-option
                v-for="(level, key) in damage_level"
                :key="key"
                :value="key"
                :label="level"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="受灾地块" prop="landList">
            <el-button
              :disabled="!!$route.query.landId && !$route.query.landIds"
              :type="requestParams.landList.length ? 'text' : 'primary'"
              @click="chooseLandHandle"
            >
              {{
                requestParams.landList.length
                  ? `已选择${requestParams.landList.length}个地块(共${requestParams.landAcre}亩)`
                  : "点击选择地块"
              }}
            </el-button>
          </el-form-item>
          <el-form-item label="经济损失" prop="damage">
            <el-input
              v-model.number="requestParams.damage"
              oninput="value=value.replace(/[^\d]/g,'')"
              maxlength="9"
              placeholder="请选择所选地块的总经济损失"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="受灾图片" prop="imgUrls">
            <div class="img-list">
              <div
                class="img-list-item"
                v-for="(img, idx) in requestParams.imgUrls"
                :key="img"
              >
                <el-image
                  :src="img"
                  :preview-src-list="requestParams.imgUrls"
                  :initial-index="idx"
                />
                <i class="el-icon-error" @click="removeImg(idx)"></i>
              </div>
              <el-upload
                :action="uploadAction"
                v-loading="uploading"
                accept="image/jpg,image/jpeg,image/png,image/bmp,image/webp"
                :show-file-list="false"
                :on-change="handleFileChange"
                :auto-upload="false"
              >
                <div class="img-add">
                  <i class="el-icon-plus"></i>
                  上传图片
                </div>
              </el-upload>
            </div>
            <div class="img-tip">最多上传3张，单张小于10MB</div>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input
              placeholder="请输入"
              v-model="requestParams.remark"
              type="textarea"
              rows="4"
              maxlength="100"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="pageSubmit">提交申请</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="land-shade" v-if="showLand && !closeOpen"></div>
      <div v-if="showLand && !closeOpen" class="land-content">
        <div class="land-content-list">
          <choose-land
            :selectLandLists="selectLandLists"
            @submit="chooseLandFun"
            @selectLandList="selectLandList"
          ></choose-land>
        </div>
        <button class="close-btn" @click="closeHandle">
          <img src="@/assets/images/common/bg-close.png" alt="" />
        </button>
      </div>
    </template>
  </main-layout>
</template>

<script>
import { snkd } from "@/api/api";
import { v4 as uuidv4 } from "uuid";
import { upload } from "@/api/request/snkd.foundation";
import MainLayout from "@/layout/MainLayout";
import {
  addDamagelabdList,
  getDamageChooselandList,
  getDamagelabdInfo,
  repeatBatchDamagelabdList,
  repeatDamagelabdList,
} from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import { cultivation_type, damage_level } from "@/confing/map_tab.js";
import ChooseLand from "./ChooseLand/Index.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "increaseLand",
  components: {
    MainLayout,
    ChooseLand,
  },
  data() {
    return {
      cultivation_type,
      damage_level,
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      requestParams: {
        disasterName: "",
        cultivationType: "",
        level: "",
        landList: [],
        damage: "",
        imgUrls: [],
        remark: "",
        landAcre: 0,
      },
      selectLandLists: [],
      rules: {
        cultivationType: [
          {
            required: true,
            message: "请选择本次要申报的栽培类型",
            trigger: "change",
          },
        ],
        level: [
          {
            required: true,
            message: "请选择本次要申报的受灾程度",
            trigger: "change",
          },
        ],
        landList: [
          {
            required: true,
            message: "请选择地块",
            trigger: "blur",
          },
        ],
        damage: [
          {
            required: true,
            message: "请输入所选地块的总经济损失",
            trigger: "blur",
          },
        ],
        imgUrls: [
          {
            required: true,
            message: "请上传受灾图片",
            trigger: "blur",
          },
        ],
      },
      companyInfo: {},
      showLand: false,
    };
  },
  async created() {
    this.$store.dispatch("getCurCompanyInfo").then((res) => {
      this.companyInfo = res.userCompany;
    });

    this.requestParams.disasterName = this.$route.query.name;
    if (this.$route.query.landId) {
      this.getDetail();
    }
    if (this.$route.query.landIds) {
      //获取农场id
      const farminfo = getStorage("FARMINFO");
      const res = await getDamageChooselandList({
        companyId: farminfo.companyId,
        farmId: farminfo.farmId,
        disasterId: this.$route.query.id,
      });
      this.requestParams.landList = res.obj;
      this.selectLandLists = this.requestParams.landList;
      this.requestParams.landAcre = this.totalAcre;
    }
    //重置数据
    this.$store.commit("damage/clearPageAllStatus");
  },
  methods: {
    getDetail() {
      getDamagelabdInfo(this.$route.query.landId).then((res) => {
        const data = res.obj;
        data.imgUrls = data.imgUrls.split(",");
        data.landList = [
          {
            id: data.landId,
            cropList: [
              {
                cropId: data.cropId,
                cropName: data.cropName,
              },
            ],
          },
        ];
        this.requestParams = res.obj;
        console.log(this.requestParams);
      });
    },
    selectLandList(evt) {
      this.selectLandLists = evt;
    },
    pageSubmit() {
      this.$refs.damageRef.validate((valid) => {
        if (valid) {
          const params = {
            ...this.requestParams,
            farmId: getStorage("FARMINFO").farmId,
            disasterId: this.$route.query.id,
            userName: this.companyInfo.companyUserName,
            companyId: this.companyInfo.companyId,
          };
          params.imgUrls = params.imgUrls.join(",");
          params.landList = this.selectLandLists;
          if (this.$route.query.landIds && this.$route.query.landIds.length) {
            repeatBatchDamagelabdList(params).then((res) => {
              if (res.respCode === 0) {
                this.$message.success("重新申报成功！");
                this.$router.back();
              }
            });
          } else if (params.id) {
            repeatDamagelabdList(params).then((res) => {
              if (res.respCode === 0) {
                this.$message.success("重新申报成功！");
                this.$router.back();
              }
            });
          } else {
            addDamagelabdList(params).then((res) => {
              if (res.respCode === 0) {
                this.$message.success("申报成功！");
                this.$router.back();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    async handleFileChange(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.requestParams.imgUrls.length === 3) {
        this.$message.error("图片最多上传3张");
        return false;
      }
      await this.submitFileForm(file);
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      this.uploading = true;
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          this.requestParams.imgUrls.push(res.obj.internetUrl);
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
        });
    },
    removeImg(idx) {
      this.requestParams.imgUrls.splice(idx, 1);
    },
    //打开地块弹框
    chooseLandHandle() {
      this.$store.commit("damage/closeLand", false);
      this.$store.commit("damage/changeShowLandMode", "ListMode");
      this.showLand = true;
    },
    // 地块选择确定
    chooseLandFun() {
      this.requestParams.landList = this.selectLandLists;
      this.requestParams.landAcre = this.totalAcre;
    },
    //关闭地块弹框
    closeHandle() {
      this.showLand = false;
      this.requestParams.landList = this.selectLandLists;
      this.requestParams.landAcre = this.totalAcre;
      //清空筛选条件
      this.$store.commit("damage/clearPageAllStatus");
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
  },
  computed: {
    ...mapState("damage", {
      closeOpen: "closeOpen",
    }),
    ...mapGetters("damage", ["hadSelectedLandList", "showLandList"]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.selectLandLists);
    },
  },
};
</script>

<style scoped lang="scss">
.increase {
  .el-icon-warning {
    color: #aaa;
  }
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    padding: 50px 350px;
    box-sizing: border-box;
    ::v-deep .el-form-item {
      margin-bottom: 30px;
    }
    ::v-deep .el-input,
    .el-textarea,
    .el-select {
      width: 300px;
    }
    .img-list {
      display: flex;
      &-item {
        position: relative;
        line-height: 1;
        ::v-deep .el-image {
          width: 100px;
          height: 100px;
          border-radius: 4px;
          margin-right: 10px;
        }
        .el-icon-error {
          position: absolute;
          right: 2px;
          top: -8px;
          font-size: 18px;
          background-color: #fff;
          border-radius: 50%;
          color: #dadada;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
    .img-add {
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      border-radius: 4px;
      color: #cccccc;
      font-size: 12px;
      border: 1px solid #dcdfe5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i {
        font-size: 18px;
      }
    }
    .img-tip {
      font-size: 14px;
      color: #888888;
      text-align: left;
    }
  }
  .land-shade {
    width: 100%;
    height: 100%;
    // background-color: pink;
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    z-index: 5;
    position: absolute;
    top: 0px;
  }
  .land-content {
    position: absolute;
    top: 13%;
    left: 15%;
    width: 1200px;
    // width: 80%;
    height: 85%;
    // background-color: pink;
    z-index: 10;
    margin: 0 auto;
    .land-content-list {
      // width: 1000px;
      width: 100%;
      height: 95%;
      // min-width: 1000px;
      background-color: #fff;
      margin: 0 auto;
      border-radius: 10px;
      padding: 10px;
      position: relative;
    }
    .close-btn {
      position: absolute;
      right: -5%;
      // top: 5px;
      top: 0;
      height: 36px;
      width: 36px;
      border: 2px solid #fff;
      border-radius: 50%;
      outline: 0;
      background-color: rgb(0, 0, 0);
      opacity: 0.2;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }
  .land-select {
    font-size: 14px;
    font-weight: 400;
    color: #64c3a4;
    cursor: pointer;
  }
}
</style>
